export default __webpack_public_path__ + "static/media/line-graph.e7d0b991.svg";